import React from 'react';

/**
 * Resumo de um registro escolhido, em pares rótulo/valor (at-67, frente D/D5).
 *
 * É o bloco que os dois modais de envio mostram depois que o TI escolhe **quem**
 * vai ser enviado ao SGA — nome/CPF/e-mail/código/regional no de associado,
 * placa/modelo/chassi/renavam/código no de veículo. Era o mesmo `<div
 * class="ti-modal-summary">` com 5 linhas iguais em cada.
 *
 * ⚠️ **Mora em `components/`, não no kit**: são **dois** consumidores, e a regra
 * do `13-ui-kit.md` é que primitivo sem consumidor plural não nasce — dois é o
 * mínimo para extrair, não o bastante para virar design system. Se o Base FIPE ou
 * o Rateio pedirem a mesma apresentação, promove-se depois (foi assim com o
 * `BotaoSelecao`, na at-62).
 *
 * ⚠️ **`<dl>` de verdade**, e não uma grade de `<div>`: para o leitor de tela,
 * "Placa: ABC1D23" é um par termo/definição, e é assim que ele o anuncia.
 */

export interface LinhaResumo {
  rotulo: string;
  /** Já formatado pelo consumidor. Vazio/ausente vira "—". */
  valor: React.ReactNode;
}

interface PropsResumoRegistro {
  linhas: LinhaResumo[];
  /** Ação de escape, ex.: "Trocar associado". Fica no rodapé do bloco. */
  acao?: React.ReactNode;
}

const ResumoRegistro: React.FC<PropsResumoRegistro> = ({ linhas, acao }) => (
  <div className="tw-rounded-xl tw-border tw-border-superficie-borda tw-bg-superficie tw-p-4">
    <dl className="tw-m-0 tw-flex tw-flex-col tw-gap-2">
      {linhas.map((linha) => (
        <div
          key={linha.rotulo}
          className="tw-flex tw-flex-wrap tw-items-baseline tw-justify-between tw-gap-x-3 tw-gap-y-0.5"
        >
          <dt className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-texto-suave">
            {linha.rotulo}
          </dt>
          <dd className="tw-m-0 tw-text-sm tw-text-texto-titulo [overflow-wrap:anywhere]">
            {linha.valor}
          </dd>
        </div>
      ))}
    </dl>

    {acao && <div className="tw-mt-3 tw-flex tw-justify-end">{acao}</div>}
  </div>
);

export default ResumoRegistro;
